import { Backdrop, Paper, styled } from "@mui/material";
import colors from "../../../theme/themeConstants";
import editIconRed from "components/icons/edit_icon.svg";
import linkIconRed from "components/icons/share-red.svg";
import categoryIconRed from "components/icons/manage_icon.svg";
import followersIconRed from "components/icons/followersIconRed.svg";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
}

const NicheActionsPopup = ({ isOpen, togglePopup }: IProps) => {

  // const handleStopPropagation = (event: React.MouseEvent) => {
  //   event.stopPropagation()
  // }

  // const handleClose = () => (event: React.MouseEvent) => {
  //   event.stopPropagation()
  //   togglePopup()
  // }

  return (
    <Backdrop open={isOpen} id={"niche-actions-popupOpen"}
      onClick={togglePopup}
      sx={{
        zIndex: "var(--popupZ)"
      }}
    >
      <Paper sx={{
        height: "auto",
        minHeight: "10rem",
        width: "-webkit-fill-available",
        position: "absolute",
        bottom: isOpen ? "0rem" : "-15rem",
        transition: "bottom 300ms cubic-bezier(0, 0, 1, 1) 0ms",
        borderRadius: "24px 24px 0 0",
        padding: "2rem 1rem 2rem 1rem",
      }}>
        <ActionsFlexContainer >
          <StyledActionPaper elevation={0} >
            <img src={editIconRed} alt="edit" />
            <p>Edit</p>
          </StyledActionPaper>
          <StyledActionPaper elevation={0} >
            <img src={linkIconRed} alt="link" />
            <p>Share</p>
          </StyledActionPaper>
          <StyledActionPaper elevation={0} >
            <img src={categoryIconRed} alt="category" />
            <p>Manage</p>
          </StyledActionPaper >
        </ActionsFlexContainer >

        <StyledActionPaper elevation={0} sx={{ width: "auto !important", marginTop: "12px" }}>
          <img src={followersIconRed} alt="followers" />
          <p>Followers</p>
        </StyledActionPaper>
      </Paper >
    </Backdrop >
  );
};

export default NicheActionsPopup;

const ActionsFlexContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
});

const StyledActionPaper = styled(Paper)({
  backgroundColor: colors.lightGrayPaperBackground,
  backgroundVisibility: 0.3,
  borderRadius: "12px",
  width: "29vw",
  height: "90px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  "& img": {
    maxHeight: "28px",
  },
  "& p": {
    marginTop: "10px",
  }
});
